import { POST_LIKE_PERMISSIONS } from './NewsboardPostLike.constants'

export function getActionPermission(permissions) {
  return (
    permissions[POST_LIKE_PERMISSIONS.like] ||
    permissions[POST_LIKE_PERMISSIONS.unlike]
  )
}

export function getLikeCount({ counters, is_liked }, liked) {
  if (liked === is_liked) {
    return counters.likes
  }

  if (liked && !is_liked) {
    return counters.likes + 1
  }

  return counters.likes - 1
}
